import { markRaw } from 'vue'
import { defineStore } from 'pinia'
import { getAssessmentItem } from './assessment_item_api'
import type { AssessmentItem } from './assessment_item_types'

export const useAssessmentItemsStore = defineStore('assessmentItems', {
  state: () => ({
    itemsById: {} as Record<string, AssessmentItem>,
    // The item modal and the printable view read the same item, so a request already in flight is
    // shared rather than repeated, and a fetched item is kept for the rest of the page.
    pendingFetchesById: markRaw(new Map<string, Promise<AssessmentItem>>())
  }),
  getters: {
    itemById: (state) => (itemId: string): AssessmentItem | undefined => state.itemsById[itemId]
  },
  actions: {
    async fetchItem(itemId: string): Promise<AssessmentItem> {
      const cachedItem = this.itemsById[itemId]
      if (cachedItem) {
        return cachedItem
      }
      const pendingFetch = this.pendingFetchesById.get(itemId) ?? getAssessmentItem(itemId)
      this.pendingFetchesById.set(itemId, pendingFetch)
      try {
        const item = await pendingFetch
        this.itemsById[itemId] = item
        return item
      } finally {
        this.pendingFetchesById.delete(itemId)
      }
    }
  }
})
